import { token } from '@gaodun.com/gtools';
import { appId } from '@/sub-luca-plugin/utils/config';

export const getAccessTokenFn = async () => {
    const accessTotken = token.getFronttoken({ AppID: appId });
    return accessTotken;
};

export const getSearchParams = (input: string): { [key: string]: string } => {
    const params: { [key: string]: string } = {};
    let queryString: string;

    // 检查是否是完整的 URL 还是仅包含 search 字符串
    if (input.includes('?')) {
        queryString = input.split('?')[1];
    } else {
        queryString = input.startsWith('?') ? input.substring(1) : input;
    }

    if (queryString) {
        const queryArray = queryString.split('&');

        queryArray.forEach(query => {
            const [key, value] = query.split('=');
            params[key] = value;
        });
    }

    return params;
};

export const searchToObject = (search: string): { [key: string]: string } => {
    const searchParams = new URLSearchParams(search);
    const result: { [key: string]: string } = {};
    searchParams.forEach((value, key) => {
        result[key] = value;
    });
    return result;
};

// 浏览器兼容弹窗
export const initCompatibleModal = () => {
    const scriptUrl = `https://gd-file.gaodun.com/browser-modal/bundle.js?v=${Date.now()}`;
    const div = document.createElement('div');
    div.id = 'adapterView';
    document.body.append(div);
    const scriptTag = document.createElement('script');
    scriptTag.src = scriptUrl;
    scriptTag.id = 'adapterView';
    document.body.appendChild(scriptTag);
    scriptTag.onload = () => {
        (window as any).useCompatibilityModal();
    };
};

// JS错误上报
export const sentryInit = () => {
    // try {
    //     Sentry.init({
    //         dsn: 'https://ed283549dc7e77c4980e29582a061002@sentry.gaodun.com/121',
    //         environment: process.env.CROSS_ENV,
    //         integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    //         tracesSampleRate: 1.0,
    //         maxBreadcrumbs: 50,
    //         profilesSampleRate: 0.01,
    //         replaysSessionSampleRate: 0,
    //         replaysOnErrorSampleRate: 0.01,
    //     });
    // } catch (error) {
    //     console.log('Sentry初始化失败', error);
    // }
};
